var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip-detail"},[_vm._t("vipDetail",[_vm._v("了解优学VIP课程包")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }